import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import LookupItemSelect from '../BaseInputs/Selectors/LookupSelect';
import TpClientPaymentMethodSelect from '../BaseInputs/Selectors/TpClientPaymentMethodSelect';
import LookupMultiChoice from '../BaseInputs/Selectors/MultiChoice/LookupMultiChoice';
import LookupItemMiscMultiChoice from '../BaseInputs/Selectors/MultiChoice/LookupItemMiscMultiChoice';

/**
 * Generic lookup-item select driven by an entry from `lookupSelectConfig`.
 * `config` = { lookupId, onlyActive?, sort?, valueAsText? }.
 */
export const renderLookupSelect = (props, { lookupId, onlyActive = false, sort = false, valueAsText = false }) => (
  <LookupItemSelect
    value={props.value}
    className={props.className}
    showSelectFilterAt={props.showSelectFilterAt}
    filterCleared={props.filterCleared}
    editedItem={props.editedItem}
    IsCheckBoxEnabled={props.IsCheckBoxEnabled}
    changeOfEditedMultipItem={props.changeOfEditedMultipItem}
    fieldName={props.fieldName}
    onChange={props.onChange}
    lookupId={lookupId}
    onlyActive={onlyActive}
    sort={sort}
    valueAsText={valueAsText}
  />
);

export const renderLookupSelectForTpClientPaymentMethod = (props) => (
  <TpClientPaymentMethodSelect
    value={props.value}
    className={props.className}
    showSelectFilterAt={props.showSelectFilterAt}
    filterCleared={props.filterCleared}
    editedItem={props.editedItem}
    IsCheckBoxEnabled={props.IsCheckBoxEnabled}
    changeOfEditedMultipItem={props.changeOfEditedMultipItem}
    fieldName={props.fieldName}
    onChange={props.onChange}
    lookupId={53}
    onlyActive={true}
    sort={true}
    valueAsText={true}
  />
);

export const renderLookupMultiChoice = (props) => (
  <LookupMultiChoice
    fieldName={props.fieldname}
    lookupId={props.selectValues}
    selected={props.value}
    onChange={(value) => props.onChange(props.fieldName, value)}
    textAsValue={props.type === InputTypesEnum.LookupTextMultiChoice}
  />
);

export const renderLookupItemMiscMultiChoice = (props) => (
  <LookupItemMiscMultiChoice
    fieldName={props.fieldName}
    lookupId={props.selectValues}
    lookupItemId={props.lookupItemId}
    selected={props.value}
    onChange={(value) => props.onChange(props.fieldName, value)}
    separatorCharacter={props.separatorCharacter}
  />
);

// The 'Approved Assignment Payment Report' lookup: its items' Misc columns hold the
// comma-separated predefined evaluator-id lists for the approved-payments export.
// lookupItemId is matched against the item's Value column (see
// LookupItemService.GetLookupItemByLookupIdAndLookupItemId).
const APPROVED_PAYMENT_REPORT_LOOKUP_ID = 116;

export const renderPredefinedEvaluatorsMultiChoice = (props) => (
  <LookupItemMiscMultiChoice
    fieldName={props.fieldName}
    lookupId={APPROVED_PAYMENT_REPORT_LOOKUP_ID}
    lookupItemId={props.type === InputTypesEnum.PredefinedTpEvaluatorsMultiChoice ? 1 : 2}
    selected={props.value}
    onChange={(value) => props.onChange(props.fieldName, value)}
    separatorCharacter=','
  />
);
